




















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';


@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
})
export default class DefaultVehicleServicePage extends Base {
    public form: any = {};
    public vehicleServiceFeilds: Array<VFields<any>> = [];
    public vehicleServiceModel = {
        id: '',
        internalName: '',
        name: '',
        serviceCode: '',

    };
    public storeId: number = 0;
    public requestProgress: boolean = false;

    public callMethod(methodName): void {
        if (methodName === 'backToStoreEdit') {
            this.$router.push({
                name: 'admin.stores.edit',
                params: {
                    id: this.storeId.toString(),
                    tab: 'DefaultVehicleServices'
                },
            })
                .catch((ex) => {
                    console.log(ex);
                });
        }
        if (methodName === 'saveVehicleService') {

            if (!this.form.$valid) {
                this.showAlert(false, 'Form is Invalid!');
                this.resetMethodName(methodName);
                return;
            }
            this.saveVehicleService();
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        if (this.storeId) {
            buttons.push({
                id: '0',
                type: 'button',
                title: this.$parent.$t('stores.btnBackToStoreTitle'),
                disabled: false,
                visible: true,
                class: 'btn',
                label: this.$parent.$t('stores.btnBack'),
                click: 'backToStoreEdit',
                icon: 'fas fa-arrow-left',
            });
        }
        this.$emit('updateToolBar', buttons);
    }

    public mounted() {
        this.storeId = Number(this.$route.params.storeId);
        this.setvehicleServiceFeilds();
        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        if (this.$route.params.id) {
            this.getVehicleService();
        }
    }

    public setvehicleServiceFeilds(): void {
        this.vehicleServiceFeilds = [

            {
                key: 'name',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    label: 'Name',
                    required: true,
                    disabled: false,
                    loading: false,
                    elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
                    rules: [
                        v => this.required('Name', v),
                    ]
                },
            },
            {
                key: 'internalName',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    label: 'Internal Name',
                    required: true,
                    disabled: false,
                    loading: false,
                    elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
                    rules: [
                        v => this.required('Internal Name', v),
                    ]
                },
            },
            {
                key: 'serviceCode',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    label: 'Service Code',
                    required: true,
                    disabled: false,
                    loading: false,
                    elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
                    rules: [
                        v => this.required('Service Code', v),
                    ]
                },
            },


        ];
    }
    public async getVehicleService(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.vehicleServiceFeilds);
            const response = await storeService.getStore(this.storeId);
            if (response && response.storeJson
                && response.storeJson.appointmentDefaultServices.length > 0) {


                const vehicleService = response.storeJson.appointmentDefaultServices;
                const selectedVehicleService = vehicleService.find(
                    (m) => m.id == this.$route.params.id
                );
                this.vehicleServiceModel = selectedVehicleService;

            }

        } finally {
            this.formlyHideSkeleton(this.vehicleServiceFeilds);
        }
    }


    public validateRefundPreset(): Vue & { validate: () => boolean } {
        return this.$refs.refVehicleServiceForm as Vue & { validate: () => boolean };
    }

    public async saveVehicleService(): Promise<void> {
        if (this.validateRefundPreset().validate()) {
            try {
                this.requestProgress = true;
                this.$emit('update:progress', this.requestProgress);
                this.formlyShowSkeleton(this.vehicleServiceFeilds);
                if (this.vehicleServiceModel.id == '') {
                    await storeService.AddAppointmentDefaultService(this.vehicleServiceModel.internalName, this.vehicleServiceModel.name, this.vehicleServiceModel.serviceCode, this.storeId);
                    this.showAlert(true, 'Vehicle Services Added successfully');
                    this.$router.push({
                        name: 'admin.stores.edit',
                        params: {
                            tab: 'DefaultVehicleServices'
                        }
                    })
                        .catch((ex) => {
                            console.log(ex);
                        });
                }
                else {

                    await storeService.UpdateAppointmentDefaultService(this.vehicleServiceModel.id, this.storeId, this.vehicleServiceModel.internalName, this.vehicleServiceModel.name, this.vehicleServiceModel.serviceCode,);
                    this.showAlert(true, 'Vehicle Services Updated successfully');
                    this.$router.push({
                        name: 'admin.stores.edit',
                        params: {
                            storeId: this.storeId.toString(),
                            tab: 'DefaultVehicleServices'
                        },
                    })
                        .catch((ex) => {
                            console.log(ex);
                        });
                }
            } finally {
                this.requestProgress = false;
                this.$emit('update:progress', this.requestProgress);
                this.formlyShowSkeleton(this.vehicleServiceFeilds);
            }
        }
    }
}
